const firebaseConfig = {
    apiKey: "AIzaSyA3ybYB0STuzO2TpKRMCFmK_dyXTBpHo08",
    authDomain: "ema-jhon-simple-818a6.firebaseapp.com",
    databaseURL: "https://ema-jhon-simple-818a6.firebaseio.com",
    projectId: "ema-jhon-simple-818a6",
    storageBucket: "ema-jhon-simple-818a6.appspot.com",
    messagingSenderId: "92994739841",
    appId: "1:92994739841:web:dfb8049ca13f754d31b780"
  };


  export default firebaseConfig;